// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAJvqCL53M66U2tvGEROkmEiGzMCDaQn_k",
  authDomain: "crud-firebase-97ffb.firebaseapp.com",
  projectId: "crud-firebase-97ffb",
  storageBucket: "crud-firebase-97ffb.firebasestorage.app",
  messagingSenderId: "724453621950",
  appId: "1:724453621950:web:a1dc6b57644670df865eef",
  measurementId: "G-G49YDF6EX0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);